export default __webpack_public_path__ + "392ba884ae44e6537b5a9ccc5b2a3836.jpg";